import * as dateFnsCompat from 'utils/date-fns-compat';

import fp from 'lodash/fp';

// For use as a placeholder
// @see https://github.com/lodash/lodash/wiki/FP-Guide#placeholders
export const _ = fp;

// Used to access index/key of the array.
// @see https://github.com/lodash/lodash/wiki/FP-Guide#convert
export const curriedRemove = fp.remove.convert({ curry: true });
export const noCapMap = fp.map.convert({ cap: false });
export const noCapMapValues = fp.mapValues.convert({ cap: false });
export const noCapFilter = fp.filter.convert({ cap: false });
export const noCapFind = fp.find.convert({ cap: false });
export const noCapRemove = fp.remove.convert({ cap: false });
export const reargCurriedConcat = fp.concat.convert({ curry: true, rearg: true });
export const unfixedConcat = fp.concat.convert({ fixed: false });
export const unfixedRound = fp.round.convert({ fixed: false });
export const unfixedZip = fp.zip.convert({ fixed: false });
export const unfixedFloor = fp.floor.convert({ fixed: false });
export const unfixedCeil = fp.ceil.convert({ fixed: false });

export const branchFuncs = fp.curry(
  (test, left, right, input) => test(input) ?
    left(input) :
    right(input)
);
export const spreadArgs = fp.curry((args, f) => fp.spread(f)(args));

export const stubNull = () => null;

export const toBoolean = (x) => x ? true : false;

export const updateIn = (list, obj, matchField) => fp.map((o) => (
  o[matchField] === obj[matchField] ?
    {
      ...o,
      ...obj
    } :
    o
))(list);

export const lastCreated = (selector) => fp.flow(
  fp.sortBy((obj) => dateFnsCompat.getTime(selector(obj).metaData.dateCreated)),
  fp.last
);



// WEBPACK FOOTER //
// ./src/utils/lodash-fp.js